import { FC } from "react";
import InnerPage from "../../shared/components/InnerPage";
import BlogCard from "./components/BlogCard";
import { BLOG_POSTS } from "./posts";

const BlogPage: FC = () => (
  <InnerPage
    eyebrow="Bilgi Merkezi"
    title="Blog"
    crumbs={[{ label: "Blog" }]}
    seoDescription="Securitas İtfaiye uzmanlarından endüstriyel yangınlar, konteyner yangınları, okullarda yangın güvenliği ve acil durum aydınlatması gibi konularda güncel yazılar."
  >
    <div className="it-post-grid" style={{ gridColumn: "1 / -1" }}>
      {BLOG_POSTS.map((post) => (
        <BlogCard post={post} key={post.slug} />
      ))}
    </div>
  </InnerPage>
);

export default BlogPage;
